let elementsForSearch = [
  // { title: 'Title', type: 'title', priority: 0 },
  { title: 'Status', type: 'status', priority: 1 },
  // { title: 'Classification', type: 'classification', priority: 2 },
  { title: 'Classification (CPV)', type: 'cpv', priority: 3 },
  { title: 'Tender ID', type: 'identifier', priority: 5 },
  // { title: 'Procurement Type', priority: 6 },
  { title: 'Bid submission deadline', type: 'date', priority: 7 },
]

export default elementsForSearch
